<template>
  <h3 class="title" :class="{
    'has-text-weight-light': light,
  }">
    <slot></slot>
  </h3>  
</template>
<script>
export default {
  props: {
    light: {
      type: Boolean
    },
    size: {
      type: String|Number
    }
  }
}
</script>